import { inject, Service } from '@angular/core';
import { ClientMetadataHeadersDto } from '@workspace/data-types';
import { environment } from '@workspace/ng-config';
import { CookieService } from 'ngx-cookie-service';
import { v4 as UUID } from 'uuid';
import { SessionStorageKey } from '../models';

@Service()
export class ClientMetadataService {
  private readonly COOKIE_DOMAIN = `.${environment.domain}`;
  private readonly COOKIE_KEY = SessionStorageKey.CLIENT_ID;
  private cookieService = inject(CookieService);

  getOrCreateClientId(): string {
    if (this.cookieService.check(this.COOKIE_KEY)) {
      return this.cookieService.get(this.COOKIE_KEY);
    }

    const newId = UUID();

    try {
      this.cookieService.set(
        this.COOKIE_KEY,
        newId,
        365,
        '/',
        this.COOKIE_DOMAIN,
        true, // Secure (HTTPS only)
        'Lax', // SameSite
      );
    } catch (err) {
      console.error('Cookie blocked:', err);
    }

    return newId;
  }

  collect(): ClientMetadataHeadersDto {
    return {
      lang: navigator.language,
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      resolution: `${screen.width}x${screen.height}`,
      clientId: this.getOrCreateClientId(),
      pixelRatio: devicePixelRatio,
      cores: navigator.hardwareConcurrency ?? null,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      memory: (navigator as any).deviceMemory ?? null,
    };
  }
}
